import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: "",
};

export const counterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    getFilter: (state, action) => {

      state.value = action.payload;
    },
    setFillter: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { getFilter, setFillter } = counterSlice.actions;

export default counterSlice.reducer;
